<template>
  <b-form-group
    class="form-group-datepicker"
    :label="label"
    :label-size="size"
    :label-class="`font-weight-bold ${(validate.required === true || (typeof validate === 'string' && validate.search('required') !== -1) ? 'is-required' : '')}`"
  >
    <ValidationProvider
        v-slot="validationContext"
        ref="inputValidation"
        :name="name"
        :rules="validate"
        :mode="validationMode"
    >
        <b-input-group >
            <b-form-input
                v-model="_value"
                type="text"
                placeholder="AAAA-MM-DD"
                :state="getValidationState(validationContext)"
                :autocomplete="autocomplete"
                :autofocus="autofocus"
                @change="onchange"
                @focus="removeReadonly"
                :disabled="disabled"
            ></b-form-input>
            <b-input-group-append>
                <b-form-datepicker
                v-model="_value"
                :name="name" 
                :label="label" 
                button-only
                no-flip
                dropleft
                hide-header 
                show-decade-nav
                :min="initialDate ? initialDate : getMinDate(min)"
                :initial-date-xxxx="min ? getMinDate(min) : null"
                locale="es"
                label-help="Seleccione una fecha" 
                :placeholder="placeholder"
                ></b-form-datepicker>
                <!-- nota: initial-date funciona, pero lo comenté porque hace que muestre como fecha inicial (al abrir el popup) la fecha mínima -->
            </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback
            v-if="showErrorMessage"
            :state="validationContext.errors.length === 0"
        >
            {{ validationContext.errors.join('. ') }}
        </b-form-invalid-feedback>
    </ValidationProvider>
  </b-form-group>
</template>

<script>
  export default {
    name: 'InputDatePicker',
    props: {
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: false,
        default: ''
      },
      placeholder: {
        type: String,
        required: false,
        default: ''
      },
      autofocus: {
        type: Boolean,
        required: false,
        default: false,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      validate: {
        type: [String, Object],
        required: false,
        default: { regex: /^(19[0-9]{2}|2[0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12]\d|3[0-1]))|(02-(0[1-9]|[12]\d))|((0[469]|11)-(0[1-9]|[12]\d|30)))$/ }
      },
      onchange: {
        type: Function,
        required: false,
        default: () => {}
      },
      value: {
        type: [String, Number],
        required: false,
        default: null,
      },
      min: {
        type: Date,
        required: false,
        default: null,
      },
      initialDate: {
        type: Date,
        required: false,
        default: null,
      },
      validationMode: {
        type: String,
        required: false,
        default: 'passive'
      },
      type: {
        type: String,
        required: false,
        default: 'text',
      },
      size: {
        type: String,
        required: false,
        default: ''
      },
      step: {
        type: Number,
        required: false,
        default: 1,
      },
      autocomplete: {
        type: String,
        required: false,
        default: ''
      },
      showErrorMessage: {
        type: Boolean,
        required: false,
        // eslint-disable-next-line vue/no-boolean-default
        default: true,
      },
      helpText: {
        type: String,
        default: ''
      },
    },
    computed: {
      _value: {
        get (obj) {
          return this.value
        },
        set (value) {
          this.$emit('update:value', value.trim())
          this.$emit('input', value.trim())
        }
      }
    },
    beforeMount() {
        this.validate["regex"] = /^(19[0-9]{2}|2[0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12]\d|3[0-1]))|(02-(0[1-9]|[12]\d))|((0[469]|11)-(0[1-9]|[12]\d|30)))$/
    },
    methods: {
      getValidationState({ validated, valid = null}) {
        return validated ? valid : null
      },
      getMinDate(min){
        if (min){
            let date = new Date(min)        
            date.setDate(date.getDate() + 1)
            return date.toISOString().slice(0, 10)
        }
        return null
      },
      removeReadonly(event){
        // fix error readonly on multiple validations?
        if(event.currentTarget.getAttribute('readonly') == 'readonly'){
          event.currentTarget.removeAttribute('readonly')
          event.currentTarget.style.backgroundColor = 'white'
        }
      },
    },
  }
</script>
<style lang="scss">
    .form-group-datepicker {
        .btn-secondary {
            border-color: #598fbd;
            background-color: white;
        }
        .show .btn-secondary {
            background-color: rgb(240, 240, 240);
            border-color: #598fbd;
        }
        
    }
</style>